import { ValidationErrorData } from '../typings/common';
import {
    OrganizationData,
    OrganizationEditorParams,
    OrganizationsBulkActionType,
    OrganizationsEditorDataStatus
} from '../typings/organizations';

export const INIT_ORGANIZATIONS_EDITORS = 'INIT_ORGANIZATIONS_EDITORS';
export type INIT_ORGANIZATIONS_EDITORS = typeof INIT_ORGANIZATIONS_EDITORS;

export interface InitOrganizationsEditors {
    type: INIT_ORGANIZATIONS_EDITORS;
    params: OrganizationEditorParams[];
}

export function initOrganizationsEditors(params: OrganizationEditorParams[]): InitOrganizationsEditors {
    return {
        type: INIT_ORGANIZATIONS_EDITORS,
        params
    };
}

export const UPDATE_ORGANIZATIONS_EDITORS_DATA = 'UPDATE_ORGANIZATIONS_EDITORS_DATA';
export type UPDATE_ORGANIZATIONS_EDITORS_DATA = typeof UPDATE_ORGANIZATIONS_EDITORS_DATA;

export interface UpdateOrganizationsEditorsData {
    type: UPDATE_ORGANIZATIONS_EDITORS_DATA;
    editorsOrganizations: Record<string, OrganizationData>;
}

export function updateOrganizationsEditorsData(
    editorsOrganizations: Record<string, OrganizationData>
): UpdateOrganizationsEditorsData {
    return {
        type: UPDATE_ORGANIZATIONS_EDITORS_DATA,
        editorsOrganizations
    };
}

export const UPDATE_ORGANIZATIONS_EDITORS_DATA_STATUS = 'UPDATE_ORGANIZATIONS_EDITORS_DATA_STATUS';
export type UPDATE_ORGANIZATIONS_EDITORS_DATA_STATUS = typeof UPDATE_ORGANIZATIONS_EDITORS_DATA_STATUS;

export interface UpdateOrganizationsEditorsDataStatus {
    type: UPDATE_ORGANIZATIONS_EDITORS_DATA_STATUS;
    editorsStatuses: Record<string, OrganizationsEditorDataStatus>;
}

export function updateOrganizationsEditorsDataStatus(
    editorsStatuses: Record<string, OrganizationsEditorDataStatus>
): UpdateOrganizationsEditorsDataStatus {
    return {
        type: UPDATE_ORGANIZATIONS_EDITORS_DATA_STATUS,
        editorsStatuses: editorsStatuses
    };
}

export const OPEN_ORGANIZATIONS_EDITOR = 'OPEN_ORGANIZATIONS_EDITOR';
export type OPEN_ORGANIZATIONS_EDITOR = typeof OPEN_ORGANIZATIONS_EDITOR;

export interface OpenOrganizationsEditor {
    type: OPEN_ORGANIZATIONS_EDITOR;
    editorKey: string;
}

export function openOrganizationsEditor(editorKey: string): OpenOrganizationsEditor {
    return {
        type: OPEN_ORGANIZATIONS_EDITOR,
        editorKey
    };
}

export const RESET_ORGANIZATIONS_EDITOR = 'RESET_ORGANIZATIONS_EDITOR';
export type RESET_ORGANIZATIONS_EDITOR = typeof RESET_ORGANIZATIONS_EDITOR;

export interface ResetOrganizationsEditor {
    type: RESET_ORGANIZATIONS_EDITOR;
    editorParams: OrganizationEditorParams;
    organization?: OrganizationData;
}

export function resetOrganizationsEditor(
    editorParams: OrganizationEditorParams,
    organization?: OrganizationData
): ResetOrganizationsEditor {
    return {
        type: RESET_ORGANIZATIONS_EDITOR,
        editorParams,
        organization
    };
}

export const REMOVE_ORGANIZATION_FROM_EDITOR = 'REMOVE_ORGANIZATION_FROM_EDITOR';
export type REMOVE_ORGANIZATION_FROM_EDITOR = typeof REMOVE_ORGANIZATION_FROM_EDITOR;

export interface RemoveOrganizationFromEditor {
    type: REMOVE_ORGANIZATION_FROM_EDITOR;
    editorKey: string;
}

export function removeOrganizationFromEditor(editorKey: string): RemoveOrganizationFromEditor {
    return {
        type: REMOVE_ORGANIZATION_FROM_EDITOR,
        editorKey
    };
}

export const CHANGE_ORGANIZATION_IN_EDITOR = 'CHANGE_ORGANIZATION_IN_EDITOR';
export type CHANGE_ORGANIZATION_IN_EDITOR = typeof CHANGE_ORGANIZATION_IN_EDITOR;

export interface ChangeOrganizationInEditor {
    type: CHANGE_ORGANIZATION_IN_EDITOR;
    editorParams: OrganizationEditorParams;
}

export function changeOrganizationInEditor(editorParams: OrganizationEditorParams): ChangeOrganizationInEditor {
    return {
        type: CHANGE_ORGANIZATION_IN_EDITOR,
        editorParams
    };
}

export const SAVE_ORGANIZATION_TO_EDITOR = 'SAVE_ORGANIZATION_TO_EDITOR';
export type SAVE_ORGANIZATION_TO_EDITOR = typeof SAVE_ORGANIZATION_TO_EDITOR;

export interface SaveOrganizationToEditor {
    type: SAVE_ORGANIZATION_TO_EDITOR;
    editorParams: OrganizationEditorParams;
}

export function saveOrganizationToEditor(editorParams: OrganizationEditorParams): SaveOrganizationToEditor {
    return {
        type: SAVE_ORGANIZATION_TO_EDITOR,
        editorParams
    };
}

export const LOAD_ORGANIZATION_EDITOR_DATA = 'LOAD_ORGANIZATION_EDITOR_DATA';
export type LOAD_ORGANIZATION_EDITOR_DATA = typeof LOAD_ORGANIZATION_EDITOR_DATA;

export interface LoadOrganizationEditorData {
    type: LOAD_ORGANIZATION_EDITOR_DATA;
    editorParams: OrganizationEditorParams;
}

export function loadOrganizationEditorData(editorParams: OrganizationEditorParams): LoadOrganizationEditorData {
    return {
        type: LOAD_ORGANIZATION_EDITOR_DATA,
        editorParams
    };
}

export const OPEN_ORGANIZATIONS_BULK_EDITOR = 'OPEN_ORGANIZATIONS_BULK_EDITOR';
export type OPEN_ORGANIZATIONS_BULK_EDITOR = typeof OPEN_ORGANIZATIONS_BULK_EDITOR;

export interface OpenOrganizationsBulkEditorAction {
    type: OPEN_ORGANIZATIONS_BULK_EDITOR;
    editorId: string;
}

export function openOrganizationsMassEditor(editorId: string): OpenOrganizationsBulkEditorAction {
    return {
        type: OPEN_ORGANIZATIONS_BULK_EDITOR,
        editorId
    };
}

export const CLOSE_ORGANIZATIONS_BULK_EDITOR = 'CLOSE_ORGANIZATIONS_BULK_EDITOR';
export type CLOSE_ORGANIZATIONS_BULK_EDITOR = typeof CLOSE_ORGANIZATIONS_BULK_EDITOR;

export interface CloseOrganizationsBulkEditorAction {
    type: CLOSE_ORGANIZATIONS_BULK_EDITOR;
    editorId: string;
}

export function closeOrganizationsBulkEditor(editorId: string): CloseOrganizationsBulkEditorAction {
    return {
        type: CLOSE_ORGANIZATIONS_BULK_EDITOR,
        editorId
    };
}

export const CHANGE_ORGANIZATION_BULK_EDITOR_ACTION_TYPE = 'CHANGE_ORGANIZATION_BULK_EDITOR_ACTION_TYPE';
export type CHANGE_ORGANIZATION_BULK_EDITOR_ACTION_TYPE = typeof CHANGE_ORGANIZATION_BULK_EDITOR_ACTION_TYPE;

export interface ChangeOrganizationBulkEditorActionTypeAction {
    type: CHANGE_ORGANIZATION_BULK_EDITOR_ACTION_TYPE;
    editorId: string;
    actionType: OrganizationsBulkActionType;
}

export function changeOrganizationBulkEditorActionType(
    editorId: string,
    actionType: OrganizationsBulkActionType
): ChangeOrganizationBulkEditorActionTypeAction {
    return {
        type: CHANGE_ORGANIZATION_BULK_EDITOR_ACTION_TYPE,
        editorId,
        actionType
    };
}

export const BULK_UPDATE_ORGANIZATIONS = 'BULK_UPDATE_ORGANIZATIONS';
export type BULK_UPDATE_ORGANIZATIONS = typeof BULK_UPDATE_ORGANIZATIONS;

export interface BulkUpdateOrganizationsAction {
    type: BULK_UPDATE_ORGANIZATIONS;
    editorId: string;
    organizationId?: string;
}

export function bulkUpdateOrganizations(editorId: string, organizationId?: string): BulkUpdateOrganizationsAction {
    return {
        type: BULK_UPDATE_ORGANIZATIONS,
        editorId,
        organizationId
    };
}

export const COPY_ORGANIZATION_EDITOR = 'COPY_ORGANIZATION_EDITOR';
export type COPY_ORGANIZATION_EDITOR = typeof COPY_ORGANIZATION_EDITOR;

export interface CopyOrganizationEditor {
    type: COPY_ORGANIZATION_EDITOR;
    srcEditorId: string;
    targetEditorId: string;
}

export function copyOrganizationEditor(srcEditorId: string, targetEditorId: string): CopyOrganizationEditor {
    return {
        type: COPY_ORGANIZATION_EDITOR,
        srcEditorId,
        targetEditorId
    };
}

export const UPDATE_ORGANIZATION_EDITOR_IDS = 'UPDATE_ORGANIZATION_EDITOR_IDS';
export type UPDATE_ORGANIZATION_EDITOR_IDS = typeof UPDATE_ORGANIZATION_EDITOR_IDS;

export interface UpdateOrganizationEditorIds {
    type: UPDATE_ORGANIZATION_EDITOR_IDS;
    organizationEditorUpdatedIds: Array<Record<string, string>>;
}

export function updateOrganizationEditorIds(
    organizationEditorUpdatedIds: Array<Record<string, string>>
): UpdateOrganizationEditorIds {
    return {
        type: UPDATE_ORGANIZATION_EDITOR_IDS,
        organizationEditorUpdatedIds
    };
}

export const DELETE_ORGANIZATION_EDITOR = 'DELETE_ORGANIZATION_EDITOR';
export type DELETE_ORGANIZATION_EDITOR = typeof DELETE_ORGANIZATION_EDITOR;

export interface DeleteOrganizationEditor {
    type: DELETE_ORGANIZATION_EDITOR;
}

export function deleteOrganizationEditor(): DeleteOrganizationEditor {
    return {
        type: DELETE_ORGANIZATION_EDITOR
    };
}

export const ACCEPT_SUGGESTED_ORGANIZATION_IN_EDITOR = 'ACCEPT_SUGGESTED_ORGANIZATION_IN_EDITOR';
export type ACCEPT_SUGGESTED_ORGANIZATION_IN_EDITOR = typeof ACCEPT_SUGGESTED_ORGANIZATION_IN_EDITOR;

export interface AcceptSuggestedOrganizationInEditor {
    type: ACCEPT_SUGGESTED_ORGANIZATION_IN_EDITOR;
    editorParams: OrganizationEditorParams;
}

export function acceptSuggestedOrganizationInEditor(
    editorParams: OrganizationEditorParams
): AcceptSuggestedOrganizationInEditor {
    return {
        type: ACCEPT_SUGGESTED_ORGANIZATION_IN_EDITOR,
        editorParams
    };
}

export const REJECT_SUGGESTED_ORGANIZATION_IN_EDITOR = 'REJECT_SUGGESTED_ORGANIZATION_IN_EDITOR';
export type REJECT_SUGGESTED_ORGANIZATION_IN_EDITOR = typeof REJECT_SUGGESTED_ORGANIZATION_IN_EDITOR;

export interface RejectSuggestedOrganizationInEditor {
    type: REJECT_SUGGESTED_ORGANIZATION_IN_EDITOR;
    editorParams: OrganizationEditorParams;
}

export function rejectSuggestedOrganizationInEditor(
    editorParams: OrganizationEditorParams
): RejectSuggestedOrganizationInEditor {
    return {
        type: REJECT_SUGGESTED_ORGANIZATION_IN_EDITOR,
        editorParams
    };
}

export const UPDATE_ORGANIZATION_EDITOR_ERRORS = 'UPDATE_ORGANIZATION_EDITOR_ERRORS';
export type UPDATE_ORGANIZATION_EDITOR_ERRORS = typeof UPDATE_ORGANIZATION_EDITOR_ERRORS;

export interface UpdateOrganizationEditorErrors {
    type: UPDATE_ORGANIZATION_EDITOR_ERRORS;
    editorKey: string;
    errors: ValidationErrorData[];
}

export function updateOrganizationEditorErrors(
    editorKey: string,
    errors: ValidationErrorData[]
): UpdateOrganizationEditorErrors {
    return {
        type: UPDATE_ORGANIZATION_EDITOR_ERRORS,
        editorKey,
        errors
    };
}

export type OrganizationsEditorAction =
    | InitOrganizationsEditors
    | UpdateOrganizationEditorIds
    | DeleteOrganizationEditor
    | UpdateOrganizationsEditorsData
    | UpdateOrganizationsEditorsDataStatus
    | OpenOrganizationsEditor
    | ResetOrganizationsEditor
    | RemoveOrganizationFromEditor
    | SaveOrganizationToEditor
    | LoadOrganizationEditorData
    | ChangeOrganizationInEditor
    | OpenOrganizationsBulkEditorAction
    | CloseOrganizationsBulkEditorAction
    | ChangeOrganizationBulkEditorActionTypeAction
    | BulkUpdateOrganizationsAction
    | CopyOrganizationEditor
    | UpdateOrganizationEditorErrors
    | AcceptSuggestedOrganizationInEditor
    | RejectSuggestedOrganizationInEditor;
